import React from "react";
import { motion } from "framer-motion";

const ROLES = [
  { name: "Artists", img: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=900&q=70" },
  { name: "Producers", img: "https://images.unsplash.com/photo-1598653222000-6b7b7a552625?auto=format&fit=crop&w=900&q=70" },
  { name: "Engineers", img: "https://images.unsplash.com/photo-1581290470409-3ad48bd92a31?auto=format&fit=crop&w=900&q=70" },
  { name: "Songwriters", img: "https://images.unsplash.com/photo-1485579149621-3123dd979885?auto=format&fit=crop&w=900&q=70" },
  { name: "DJs", img: "https://images.unsplash.com/photo-1571266028243-d220c6a93c75?auto=format&fit=crop&w=900&q=70" },
  { name: "Managers", img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=70" },
  { name: "A&Rs", img: "https://images.unsplash.com/photo-1551817958-d9d86fb29431?auto=format&fit=crop&w=900&q=70" },
  { name: "Tour Crew", img: "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=900&q=70" },
  { name: "Videographers", img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=900&q=70" },
  { name: "Photographers", img: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?auto=format&fit=crop&w=900&q=70" },
  { name: "Session Musicians", img: "https://images.unsplash.com/photo-1511735111819-9a3f7709049c?auto=format&fit=crop&w=900&q=70" },
  { name: "Promoters", img: "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?auto=format&fit=crop&w=900&q=70" },
  { name: "Studio Owners", img: "https://images.unsplash.com/photo-1519508234439-4f23643125c1?auto=format&fit=crop&w=900&q=70" },
  { name: "Creative Directors", img: "https://images.unsplash.com/photo-1493612276216-ee3925520721?auto=format&fit=crop&w=900&q=70" },
];

export const RolesGrid = () => {
  return (
    <section
      id="roles"
      data-testid="roles-grid-section"
      className="relative bg-loudar-ink py-24 md:py-32"
    >
      <div className="container-loudar">
        <div className="mb-12 md:mb-16">
          <span className="label-mono">03 — Built for every role</span>
          <h2
            data-testid="roles-headline"
            className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl"
          >
            Built For Every Side Of The Industry.
          </h2>
          <p className="mt-4 max-w-2xl text-white/60 md:text-lg">
            Because every role matters in the room.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-7">
          {ROLES.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.03 }}
              data-testid={`role-card-${r.name.toLowerCase().replace(/\s|&/g, "-")}`}
              className="group relative aspect-[4/5] overflow-hidden rounded-sm border border-white/[0.08] bg-loudar-surface"
            >
              <img
                src={r.img}
                alt={r.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-30 grayscale transition-all duration-700 group-hover:scale-110 group-hover:opacity-70 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-loudar-ink via-loudar-ink/30 to-transparent transition-opacity duration-500 group-hover:from-loudar-ink/90" />
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <div className="font-display text-xl uppercase leading-tight tracking-tight text-white sm:text-2xl">
                  {r.name}
                </div>
                <div className="mt-1 h-px w-8 bg-loudar-orange transition-all duration-500 group-hover:w-full" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RolesGrid;
